import { http } from '@packet/management/src/api/http';
import type {
  CreateOrganizationRequest,
  UpdateOrganizationRequest,
  GetOrganizationListRequest,
  GetOrganizationListResponse,
  GetOrganizationDetailRequest,
  GetOrganizationDetailResponse,
  DeleteOrganizationRequest,
} from '../../DTO/organization';
import type { ApiResponse } from '../../DTO/common';

/**
 * 获取组织列表
 */
export const getOrganizationList = async (params: GetOrganizationListRequest): Promise<ApiResponse<GetOrganizationListResponse>> => {
  return http().get('/api/v1/organizations/list', params);
};

/**
 * 创建组织
 */
export const createOrganization = async (data: CreateOrganizationRequest): Promise<ApiResponse<null>> => {
  return http().post('/api/v1/organizations/create', data);
};

/**
 * 更新组织
 */
export const updateOrganization = async (data: UpdateOrganizationRequest): Promise<ApiResponse<null>> => {
  return http().put('/api/v1/organizations/update', data);
};

/**
 * 删除组织
 */
export const deleteOrganization = async (params: DeleteOrganizationRequest): Promise<ApiResponse<null>> => {
  return http().del(`/api/v1/organizations/delete?id=${params.id}`);
};

/**
 * 获取组织详情
 */
export const getOrganizationDetail = async (params: GetOrganizationDetailRequest): Promise<ApiResponse<GetOrganizationDetailResponse>> => {
  return http().get('/api/v1/organizations/get', params);
};
